export const ICON_CIRCLE_TEST_ID = 'ICON-COLOR-STATUS';
